<template>
  <div>
    <v-avatar
      size="100"
      class="mb-5"
      v-if="widget.data.brand"
    >
      <img
        :src="widget.data.brand"
        style="object-fit: cover"
      >
    </v-avatar>
    <h3 class="font-weight-bold mb-2 mt-4">
      {{$t('thankYouPage.disconnected.title')}}
    </h3>
    <p class="text--secondary pb-5">
      {{$t('thankYouPage.disconnected.description')}}
    </p>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  computed: {
    widget () {
      return this.$store.state.widget
    }
  }
})
export default class Disconnected extends Vue {}
</script>
